import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

/* ─── Types ──────────────────────────────────────────────────────────── */

interface GetCreditNotesParams {
  search?:      string;
  branchId?:    string;
  serviceType?: string;
  page?:        number;
  limit?:       number;
}

/* ─── API ────────────────────────────────────────────────────────────── */

// GET /credit-notes — search matches customer name, mobile number, or credit
// note number (case-insensitive partial match).
export const creditNoteApi = createApi({
  reducerPath: 'creditNoteApi',
  baseQuery:   dynamicBaseQuery,
  tagTypes:    ['CreditNote'] as const,
  endpoints:   (builder) => ({
    getCreditNotes: builder.query<unknown, GetCreditNotesParams | void>({
      query: (params) => {
        const { search, branchId, serviceType, page, limit } = params || {};
        const qp = new URLSearchParams();
        if (search)        qp.append('search', search);
        if (branchId)      qp.append('branchId', branchId);
        if (serviceType)   qp.append('serviceType', serviceType);
        if (page  != null) qp.append('page', String(page));
        if (limit != null) qp.append('limit', String(limit));
        const qs = qp.toString();
        return { url: qs ? `/credit-notes?${qs}` : `/credit-notes`, method: 'GET' };
      },
      providesTags: ['CreditNote'],
    }),
  }),
});

export const { useGetCreditNotesQuery } = creditNoteApi;
